import React from "react";
import { Stack, CircularProgress } from "@mui/material";

const ImagePreview = ({ presignedUrl, handleClick, fileName }) => {
  return (
    <Stack
      sx={{
        display: "flex",
        padding: "4px",
        borderRadius: "12px",
        border: "1px solid",
        borderColor: "divider",
        alignItems: "center",
        width: 250,
        height: 250,
      }}
    >
      <Stack
        onClick={handleClick}
        sx={{
          width: "100%",
          height: "100%",
          cursor: "pointer",
          borderRadius: "8px",
          overflow: "hidden",
          backgroundColor: "action.hover",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {presignedUrl ? (
          <img
            src={presignedUrl}
            alt={fileName}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              display: "block",
            }}
          />
        ) : (
          <CircularProgress color="primary" size={24} />
        )}
      </Stack>
    </Stack>
  );
};

export default ImagePreview;
